export default "icons-flash-danger"